import React from "react";
import { Link, useLocation } from "react-router-dom";

const content: Record<
  string,
  {
    title: string;
    intro: string;
    sections: Array<{ heading: string; body: string }>;
  }
> = {
  "/about": {
    title: "About StanceKit",
    intro:
      "StanceKit helps organizations develop, compare, and publish positions.",
    sections: [
      {
        heading: "One working record",
        body: "Keep source material, personal input, adopted positions, and publication history together.",
      },
      {
        heading: "Private review. Public guidance.",
        body: "Work privately, then publish a stable guide and PDF after every position is adopted.",
      },
    ],
  },
  "/cookies": {
    title: "Cookie notice",
    intro: "StanceKit currently uses one required session cookie.",
    sections: [
      {
        heading: "Required session",
        body: "The HTTP-only cookie keeps you signed in and uses SameSite restrictions. StanceKit does not use advertising or cross-site tracking cookies.",
      },
    ],
  },
};

export function StaticPage() {
  const location = useLocation();
  const page = content[location.pathname] ?? content["/about"]!;
  return (
    <div className="page-section prose-page">
      <div className="container narrow">
        <p className="kicker">StanceKit</p>
        <h1>{page.title}</h1>
        <p className="lead">{page.intro}</p>
        {page.sections.map((section) => (
          <section key={section.heading}>
            <h2>{section.heading}</h2>
            <p>{section.body}</p>
          </section>
        ))}
        <p>
          <Link className="text-link" to="/">
            Return home
          </Link>
        </p>
      </div>
    </div>
  );
}
